const SUMMARY_ITEMS = {
  TIMELINE: 'Timeline',
  KEY_INFORMATION: 'Key Information',
  PRODUCTION_AND_RESERVES: 'Production & Reserves',
  FINANCIAL_CONSIDERATIONS: 'Financial Considerations',
  LEAD_ANALYST: 'Lead Analyst',
} as const;

export { SUMMARY_ITEMS };
